import React from 'react';
import { Box, HStack, Switch, Text, VStack } from '@chakra-ui/react';
import SubtleNote from '@/components/common/SubtleNote';

interface IndefiniteConfirmationProps {
	confirmed: boolean;
	onConfirmedChange: (value: boolean) => void;
}

const IndefiniteConfirmation: React.FC<IndefiniteConfirmationProps> = ({ confirmed, onConfirmedChange }) => {
	return (
		<VStack align="stretch" gap={3} pt={4} pb={1}>
			<SubtleNote>
				{/* TODO: chakra-migration lineHeight — 1.55 is deliberate here and overrides the vocabulary's 1.5 */}
				<Text textStyle="body.sm" fontStyle="italic" lineHeight={1.55}>
					Access remains active until removed, even if relationships or circumstances change.
				</Text>

				<HStack justify="space-between" align="center" gap={4} pt={2}>
					{/* TODO: chakra-migration lineHeight — 1.4 is deliberate here and overrides the vocabulary's 1.5 */}
					<Text textStyle="label" lineHeight={1.4}>
						Confirm ongoing access
					</Text>
					<Box p={1} mr={-1} flexShrink={0}>
						<Switch.Root
							checked={confirmed}
							onCheckedChange={(details) => onConfirmedChange(details.checked as boolean)}
							size="md"
							colorPalette="green"
						>
							<Switch.HiddenInput />
							<Switch.Control />
						</Switch.Root>
					</Box>
				</HStack>
			</SubtleNote>
		</VStack>
	);
};

export default IndefiniteConfirmation;
